// Maps a notification's `resource_type` to the route that shows that resource.
//
// The registry is here so the shared notifications UI doesn't have to know about any feature's
// routes; each feature registers its own resolver at module scope (see the Signal registration
// imported from `@/routes/signal`).
const resolvers = new Map()

export function registerNotificationResourceRoute(resourceType, resolve) {
    resolvers.set(resourceType, resolve)
}

// The route for `notification`, or null when its type is unregistered or it names no resource.
export function resolveNotificationResourceRoute(notification) {
    const resolve = resolvers.get(notification?.resource_type)

    return resolve && notification.resource_id ? resolve(notification) : null
}
